import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import $ from "jquery";

class RoomRequestStatuses extends Component {
    state = { roomRequestStatusesList: null, noPermission: false };

    getRoomRequestStatusesList = async () => {
        const { fetchURL, filter, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/room-request-statuses`, {
                credentials: "include",
                method: "POST",
            });

            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const roomRequestStatuses = fetchedData.roomRequestStatuses;
                        if (filter) {
                            roomRequestStatuses.unshift({
                                key: roomRequestStatuses.length + 1,
                                value: "all",
                                text: t("selectAll"),
                            });
                        }
                        this.setState({ roomRequestStatusesList: roomRequestStatuses });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getRoomRequestStatusesList();
    }

    render() {
        const { roomRequestStatusesList, noPermission } = this.state;
        const { onChangeRoomRequestStatusesValue, defaultValue, req, id, t } = this.props;
        return (
            <Fragment>
                <Form.Label>
                    {t("room.bookStatus")} {req && <span className="required">*</span>}
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Fragment>
                        {roomRequestStatusesList ? (
                            <Dropdown
                                className="mb-3"
                                placeholder={t("form.choose")}
                                fluid
                                selection
                                defaultValue={defaultValue}
                                options={roomRequestStatusesList}
                                onChange={(event, { value }) => {
                                    $(`#${id}`).removeClass("danger");
                                    onChangeRoomRequestStatusesValue(value);
                                }}
                                id={id}
                            />
                        ) : (
                            <LoadingProgressBar t={t} />
                        )}
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default RoomRequestStatuses;
